module.exports = __webpack_public_path__ + "media/site/images/svg/crucial_data_orbs-8f496dc8d629de0f7b6231dc42cb96bc.svg";